<template>
  <div>
    <header-applis titre="Personnaliser l'offre à votre profil" sous-titre="Communiquer à l'écrit dans le monde professionnel" index-progression-courante="3"
                   index-progression-secondaire="2"/>
    <choix-competence-repeater :competences="competences" :callback="sauvegarder"/>
    <skip-competences ecrant-suivant="mobiliserraisonnements"/>
    <footer-applis ecran-precedent="communiqueroral" ecran-suivant="activitesquotidiennes" label-suivant="Je ne souhaite pas répondre aux questions"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';
import ChoixCompetenceRepeater from '../../components/ChoixCompetenceRepeater';
import SkipCompetences from '../../components/SkipCompetences';

export default {
  name: 'communiquerecrit',
  components: {
    SkipCompetences,
    ChoixCompetenceRepeater,
    HeaderApplis,
    FooterApplis
  },
  data() {
    return {
      competences: [{
        niveau: 1,
        valeur: 'Je comprends et remplis partiellement les écrits liés à mon identité et à mon projet professionnel',
      }, {
        niveau: 2,
        valeur: 'Je comprends et produis des écrits courts. Je rédige des écrits courts liés à mon projet avec aide',
      }, {
        niveau: 3,
        valeur: 'Je comprends des écrits nécessaires à mon parcours. Je structure les écrits en relation',
      }, {
        niveau: 4,
        valeur: 'Je comprends des écrits variés liés à un emploi ou à une qualification. Je produis des écrits adaptés'
      }]
    }
  },
  methods: {
    competencesTransversales() {
      return this.$store.getters.getCompetencesTansversales;
    },
    sauvegarder(competence) {
      let informations = {};
      Object.assign(informations, this.competencesTransversales());
      informations.communiquerecrit = competence;
      this.$store.commit('setCompetencesTransversales', informations);
      this.$router.push('mobiliserraisonnements');
    }
  }
}
</script>